/**
 * String tools.
 */
H_Tools.string = (() => {
    // console.log('String tools initialized');

    /**
     * Make a string's first character uppercase.
     *
     * @see https://www.php.net/manual/en/function.ucfirst.php - Just like in PHP
     *
     * @param {*} string A string
     * @returns          The supplied string with the first character capitalized
     */
    function ucfirst(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    // Return an object to expose inner functions
    return {
        ucfirst: ucfirst,
    };
})();
